import React from 'react';

interface CampaignBuilderSkeletonProps {
  className?: string;
}

const CampaignBuilderSkeleton: React.FC<CampaignBuilderSkeletonProps> = ({
  className = '',
}) => {
  return (
    <div className={`min-h-[calc(100vh-100px)] bg-gray-50 ${className}`}>
      {/* Top Navigation Bar Skeleton */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-full mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Campaign Name Skeleton */}
            <div className="flex items-center gap-2">
              <div className="h-6 bg-gray-200 rounded animate-pulse w-48"></div>
              <div className="h-4 w-4 bg-gray-200 rounded animate-pulse"></div>
            </div>

            {/* Step Indicator Skeleton */}
            <div className="hidden lg:flex items-center gap-2 flex-1 justify-center">
              {Array.from({ length: 5 }).map((_, index) => (
                <React.Fragment key={index}>
                  <div className="flex flex-col items-center">
                    <div className="flex items-center gap-1.5">
                      <div className="w-4 h-4 bg-gray-200 rounded-full animate-pulse"></div>
                      <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                    </div>
                  </div>
                  {index < 4 && <div className="w-2 h-0.5 bg-gray-200"></div>}
                </React.Fragment>
              ))}
            </div>

            {/* Action Buttons Skeleton */}
            <div className="flex items-center gap-2 lg:gap-3">
              <div className="h-9 bg-gray-200 rounded-lg animate-pulse w-20"></div>
              <div className="h-9 bg-gray-200 rounded-lg animate-pulse w-20"></div>
              <div className="h-9 bg-gray-200 rounded-lg animate-pulse w-16"></div>
              <div className="h-9 bg-gray-200 rounded-lg animate-pulse w-16"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="p-6">
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="mb-6 space-y-4">
            <div className="h-8 bg-gray-200 rounded animate-pulse w-64"></div>
            <div className="h-4 bg-gray-200 rounded animate-pulse w-96"></div>
          </div>

          {/* Content Cards */}
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="space-y-4">
                <div className="h-6 bg-gray-200 rounded animate-pulse w-48"></div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {Array.from({ length: 6 }).map((_, index) => (
                    <div
                      key={index}
                      className="h-32 bg-gray-100 rounded-lg animate-pulse"
                    ></div>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="space-y-4">
                <div className="h-6 bg-gray-200 rounded animate-pulse w-48"></div>
                <div className="space-y-3">
                  {Array.from({ length: 4 }).map((_, index) => (
                    <div
                      key={index}
                      className="h-12 bg-gray-100 rounded animate-pulse"
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignBuilderSkeleton;
